import { createAction } from '@ngrx/store';

class CelebrationActions {
  get REQUEST_CONFETTI() {
    return `[Confetti][Request]`;
  }

  RequestConfetti = createAction(this.REQUEST_CONFETTI);
}

export const Celebration = new CelebrationActions();
